import mapValues from 'lodash/mapValues';

export const appendCSSUnit = (value: string | number, unit = 'px') => {
  return value + unit;
};

export const parseBoolean = (value: unknown) => {
  return value === true || value === 'true';
};

export const stringifyObjectValues = (properties: Record<string, any>) =>
  mapValues(properties, String);
